import React, { useState } from "react";

import axios from "../../utils/axios";

import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  Input,
  Textarea,
  Box,
  Flex,
  Divider,
  Text,
  useColorModeValue,
  useToast,
  Stack,
  Checkbox,
} from "@chakra-ui/react";

import { useDispatch } from "react-redux";
import { getProspects } from "../../redux/actions/prospectActions";

import { AiOutlineDelete } from "react-icons/ai";
import { BiBrain } from "react-icons/bi";

const AddProspect = ({ isOpen, onOpen, onClose }) => {
  const activevariant = useColorModeValue("secondary", "primary");
  const dispatch = useDispatch();
  const toast = useToast();

  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    designation: "",
    domain: "",
    description: "",
    address: "",
    subject: "",
    message: "",
    followUpMessage: "",
    url: "",
    company_linkedin_url: "",
    err: "",
    success: "",
    messages: [{ subject: "", message: "", prompt: "", prompt_status: false }],
    profile_scrapping: 0,
    company_scrapping: 0,
    prompt_status: 0,
  };

  const [state, setState] = useState(initialState);

  // const [messages, setMessages] = useState([{ subject: "", message: "" }]);

  const {
    firstName,
    lastName,
    email,
    phone,
    company,
    designation,
    domain,
    description,
    address,
    subject,
    message,
    messages,
    followUpMessage,
    url,
    company_linkedin_url,
    profile_scrapping,
    company_scrapping,
    prompt_status,
    err,
    success,
  } = state;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState({ ...state, [name]: value, err: "", success: "" });
  };

  const handleSubmit = async (messages) => {
    try {
      // const msg = message.replace(/<br\s?\/?>/g, "\n");
      console.log("Beofre request....", state);
      await axios.post("/api/emails/add", state);
      toast({
        title: "Prospect Added Successfully.",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "bottom-left",
      });
      dispatch(getProspects());
      onClose(setState(initialState));
    } catch (error) {
      console.log(error.message);
      toast({
        title: error.message,
        status: "danger",
        duration: 2000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  const messageHandleAddClick = () => {
    // setMessages([...messages, { subject: "", message: "" }]);

    setState((prevState) => ({
      ...prevState,
      messages: [
        ...prevState.messages,
        { subject: "", message: "", prompt: "", prompt_status: false },
      ],
    }));
  };

  const keyHandleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...messages];
    list[index][name] = value;
    // setMessages(list);
    setState((prevState) => ({ ...prevState, messages: list }));
    console.log(messages, "All Messages");
  };

  const hanldeClickPrompt = (e, index) => {
    const { name, value } = e.target;
    const list = [...messages];
    list[index]["prompt_status"] = !list[index]["prompt_status"];
    // setMessages(list);
    setState((prevState) => ({ ...prevState, messages: list }));
    console.log(messages, "All Messages");
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    // console.log(checked);

    setState((prevState) => ({ ...prevState, [name]: checked ? 1 : 0 }));
    console.log(state);
  };

  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        variant={activevariant}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Add New Prospet</DrawerHeader>

          <DrawerBody>
            <Text fontSize="lg" fontWeight="600" mb="2">
              Prospect Details
            </Text>
            <Input
              type="text"
              placeholder="First Name"
              mb="2"
              name="firstName"
              value={firstName}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Last Name"
              mb="2"
              name="lastName"
              value={lastName}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Email Address"
              mb="2"
              name="email"
              value={email}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Contact No."
              mb="2"
              name="phone"
              value={phone}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Organization"
              mb="2"
              name="company"
              value={company}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Domain"
              mb="2"
              name="domain"
              value={domain}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Designation"
              mb="2"
              name="designation"
              value={designation}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Description"
              mb="2"
              name="description"
              value={description}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="Address"
              mb="2"
              name="address"
              value={address}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="LinkedIn Profile URL"
              mb="2"
              name="url"
              value={url}
              onChange={handleChange}
            />
            <Input
              type="text"
              placeholder="LinkedIn Company URL"
              mb="2"
              name="company_linkedin_url"
              value={company_linkedin_url}
              onChange={handleChange}
            />
            <Stack py={5} spacing={5} direction="row">
              <Checkbox
                name="profile_scrapping"
                onChange={(e) => handleCheckbox(e)}
              >
                LinkedIn Profile Scrap
              </Checkbox>
              <Checkbox
                name="company_scrapping"
                onChange={(e) => handleCheckbox(e)}
              >
                LinkedIn Company Scrap
              </Checkbox>
              <Checkbox
                name="prompt_status"
                onChange={(e) => handleCheckbox(e)}
              >
                AI Automation
              </Checkbox>
            </Stack>

            <Divider my="3" />
            <Text fontSize="lg" fontWeight="600" mb="2">
              Email Message
            </Text>
            {/* <Input
              type="text"
              placeholder="Subject"
              mb="2"
              name="subject"
              value={subject}
              onChange={handleChange}
            /> */}
            {/* <Textarea
              placeholder="Message"
              name="message"
              value={message}
              resize="none"
              mb="2"
              onChange={handleChange}
            />
            <Textarea
              placeholder="Follow up message"
              name="followUpMessage"
              value={followUpMessage}
              resize="none"
              onChange={handleChange}
            /> */}

            {messages.length > 0 &&
              messages.map((x, i) => {
                return (
                  <Box position="relative" key={i}>
                    <Flex
                      position={"absolute"}
                      top="-5px"
                      right="-5px"
                      zIndex={2}
                    >
                      <Button
                        size="xs"
                        mr={1}
                        colorScheme="orange"
                        onClick={(e) => hanldeClickPrompt(e, i)}
                      >
                        <BiBrain />
                      </Button>
                      <Button size="xs" colorScheme="orange">
                        <AiOutlineDelete />
                      </Button>
                    </Flex>
                    <Box>
                      <Input
                        type="text"
                        placeholder={`Subject ${i + 1}`}
                        mb="2"
                        name="subject"
                        value={x.subject}
                        onChange={(e) => keyHandleInputChange(e, i)}
                      />
                      <Textarea
                        key={i}
                        placeholder={`Write prompt ${i + 1}`}
                        name="prompt"
                        value={x.prompt}
                        resize="none"
                        mb="3"
                        onChange={(e) => keyHandleInputChange(e, i)}
                        display={x.prompt_status ? "block" : "none"}
                      />
                      <Textarea
                        key={i}
                        placeholder={`message ${i + 1}`}
                        name="message"
                        value={x.message}
                        resize="none"
                        mb="3"
                        onChange={(e) => keyHandleInputChange(e, i)}
                      />
                    </Box>
                  </Box>
                );
              })}

            {/* Multiple Messages Inputs */}
            <Button
              colorScheme="orange"
              width={"full"}
              mb="3"
              mt="3"
              onClick={messageHandleAddClick}
            >
              Add New
            </Button>
          </DrawerBody>

          <DrawerFooter>
            <Flex direction={"column"} w="100%">
              <Button
                colorScheme="blue"
                mb="3"
                onClick={() => handleSubmit(messages)}
              >
                Save
              </Button>
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default AddProspect;
